import ListItemIcon from "@mui/material/ListItemIcon";
import HistoryIcon from "@mui/icons-material/History";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import EditIcon from "@mui/icons-material/Edit";
import { useTheme } from "@emotion/react";

export function useCarOptions() {
  const theme = useTheme();

  return [
    {
      label: "עריכה",
      icon: (
        <ListItemIcon sx={{ color: theme.colors.main_color }}>
          <EditIcon fontSize="small" />
        </ListItemIcon>
      ),
      href: "",
    },
    {
      label: "הסטוריה",
      icon: (
        <ListItemIcon sx={{ color: theme.colors.main_color }}>
          <HistoryIcon fontSize="small" />
        </ListItemIcon>
      ),
      href: "history",
    },
    {
      label: "מסמכים",
      icon: (
        <ListItemIcon sx={{ color: theme.colors.main_color }}>
          <ContactPageIcon fontSize="small" />
        </ListItemIcon>
      ),
      href: "documents",
    },
  ];
}
